export default "__VITE_ASSET__AkK$Eazx__"